<template>
  <div id="channelBox" class="statv_wrapper">
    <h3 class="disabled"> CHANNEL NUMBER </h3>
    <div class="channel_header" v-show="channels.length > 0">
      <p class="title"><span> CHANNEL NUMBER </span></p>
    </div>
    <div class="channel_contents">
      <div 
        class="channel_item"
        v-for="(channel, idx) in channels" 
        :key="`channel_${idx}`">
        <div class="channel_name"> {{channel.name}}</div>
        <div class="channel_num"> {{channel.number}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import * as Store from '@/store/modules/channel'
export default {
	data() {
		return {

		}
	},
	computed: {
		...Store.mapState([
		'channels'
		]),
	},
	async created() {
		await this.getChannels()
	},
	methods: {
		...Store.mapActions([
		'getChannels'
		]),
	}
}
</script>
<style lang="less">
#channelBox {
  .channel_header {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    color: #ff0043;
    letter-spacing: 0;
    margin-bottom: 5px;
    &::before, &::after {
      content: "";
      position: absolute;
      width: 425px;
      border-bottom: 2px solid transparent;
      box-sizing: inherit;
      border-bottom-color: #ff0043;
      transition: width 0.3s ease-out, height 0.3s ease-out 0.3s;
    }
    &::before {
      left: 0;
      transition: 0.3s;
    }
    &::after {
      right: 0;
      transition: 0.3s;
    }
    .title {
      font-size: 36px;
      font-weight: normal;
      font-family: "BebasNeue";
    }
  }
  .channel_contents {
    display: flex;
    flex-flow: row wrap;
    height: 100px;
    .channel_item {
      display: flex;
      flex-flow: column wrap;
      justify-content: center;
      align-items: center;
      flex: 1 1 0;
      &:nth-child(2n-1) {
        .channel_name {
          background-color: #ff0043;
          color: #ffffff;
        }
      }
      .channel_name {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        order: 0;
        flex: 1 1 auto;
        font-weight: 900;
        font-size: 24px;
        color: #ff0043;
        background-color: #FEE8DF;
      }
      .channel_num {
        display: flex;
        align-items: center;
        order: 1;
        color: #ff0043;
        flex: 1 0 auto;
        font-weight: 900;
        font-size: 30px;
        &::before {
          content: "ch";
          font-weight: normal;
        }
      }
    }
  }
}

.m #channelBox {
  .channel_header {
    margin-bottom: 13px;
    &::before, &::after {
      width: calc((100% - 314px)/2);
    }
    .title {
      font-size: 50px;
    }
  }
  .channel_contents {
    display: flex;
    flex-flow: row wrap;
    height: 100px;
    .channel_item {
      .channel_name {
        height: 46px;
      }
      .channel_num {
        margin-top: 10px;
        font-size: 36px;
      }
    }
  }

}
</style>